export default __webpack_public_path__ + "static/media/c3.c6a8c99c.jpg";